module.exports = __webpack_public_path__ + "img/maciej-smc.08fb1a68.jpg";